import { hysteriFetch, wrappers } from 'hysterics';
import logger from 'ws-scripts/modules/logger';

const fetcher = hysteriFetch('ws-offer-progress-dr-admin-config-fetch');

export default async (mmdId) => {
	try {
		const drAdminConfig = await fetcher(
			`/api/widget/ws-inv-data/getDealerDRConfig/${mmdId}`,
			{
				method: 'GET',
				credentials: 'omit',
				headers: {
					Accept: 'application/json'
				}
			},
			{
				[wrappers.timeout.contextKey]: {
					timeout: 5000
				},
				[wrappers.retry.contextKey]: {
					retries: 1
				}
			}
		);

		// Check if hysteriFetch returned an error response
		if (
			drAdminConfig?.status >= 400 ||
			drAdminConfig?.name?.includes('Error')
		) {
			const errorText = `WS-OFFER-PROGRESS ->
				DR-ADMIN-CONFIG Error retrieving Admin Configs: ${drAdminConfig.status} ${
				drAdminConfig.statusText || drAdminConfig.message
			}`;
			logger.error(errorText);
			return { error: drAdminConfig };
		}

		return drAdminConfig;
	} catch (err) {
		const errorText = `WS-OFFER-PROGRESS -> DR-ADMIN-CONFIG Error retrieving Admin Configs: ${err.message}`;
		logger.error(errorText);
		return { error: err };
	}
};
